import gql from 'graphql-tag'
export const resolvers = {
  Order: {
    showDetail: () => {
      return false
    }
  },
  Product: {
    selected: () => {
      return false
    },
    currentQuantity: parent => {
      return parent.quantity
    },
    showDetail: () => {
      return false
    }
  },
  Inventory: {
    showQuantityInput: () => {
      return false
    },
    newQuantity: parent => {
      return parent.quantity
    }
  },
  SupplyOrderProduct: {
    selected: () => false
  },
  Category: {
    selected() {
      return false
    }
  }
}
export const typeDefs = gql`
  extend type Order {
    showDetail: Boolean
  }
  extend type Product {
    selected: Boolean
    currentQuantity: Int
    showDetail: Boolean
  }
  extend type Inventory {
    showQuantityInput: Boolean
    newQuantity: Int
  }
  extend type SupplyOrderProduct {
    selected: Boolean
  }
  extend type Category {
    selected: Boolean
  }
`



// WEBPACK FOOTER //
// ./src/resolvers.js